
import {Component, Prop, Vue, Watch} from 'vue-property-decorator';
import {DocSection} from '../../service/kk-help-doc/doc-section';
import {DocParagraph, listDocParagraph} from '../../service/kk-help-doc/doc-paragraph';
import {hideLoading, showLoading, showWarning} from '@/utils/message';
import marked from 'marked';
import hljs from 'highlight.js';
import './markdown.css';
import 'highlight.js/styles/github-gist.css';

@Component
export default class DocParagraphList extends Vue {
  @Prop({required: true})
  public sections!: DocSection[];

  public section: DocSection | null = null;

  public list: DocParagraph[] = [];

  @Watch('sections')
  public watchSection() {
    this.fetchData();
  }

  public created() {
    this.fetchData();
  }

  public fetchData() {
    showLoading();
    this.section = this.sections[this.sections.length - 1];
    this.list = [];
    listDocParagraph(this.section.id)
        .then((list) => {
          this.list = list;
        })
        .catch(showWarning)
        .finally(hideLoading);
  }

  public markdownToHtml(src: string): string {
    return marked(src, {
      highlight: (code: string, language: string) => {
        const validLanguage = hljs.getLanguage(language) ? language : 'plaintext';
        return hljs.highlight(validLanguage, code).value;
      },
    });
  }
}
